.root {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
}

.label {
  overflow-wrap: anywhere;
}

/* The linked entity is a reference under the label: smaller and quieter, still clickable. */
.reference {
  font-size: 0.8125rem;
  opacity: 0.75;
}
